import React, { useState, memo, useEffect, useMemo, useContext } from "react";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast  from 'react-hot-toast';
import Select from "react-select";
import AsyncSelect from 'react-select/async';

// Pages
import Breadcrumbs from "../../components/common/Breadcrumb";
import currencies from "../../utils/currency/currency.json";
import {
  transportType
} from "../../utils/constants";
import {
  handleAddSubProductApi,
  getAllSubProductDetailsApi,
  handleChangeSubProductStatusApi,
  getProductRelateDetailsApi
} from "../../api/productApi";
import { getAllActiveManufacturersApi } from "../../api/vendorApi"

import {
  getAllActiveDistributorsApi,
  handleAddEditDistributorApi
} from "../../api/distributorApi"
import { AuthContext } from "../../contexts/AuthContext";
import { useAppSettings } from '../../contexts/AppSettingsContext';

function SubProduct() {
  const { appSettings } = useAppSettings();
  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const [subProductModal, setSubProductModal] = useState(false);
  const [storeTags, setStoreTags] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [subProducts, setSubProducts] = useState([]);
  const { authToken }  = useContext(AuthContext);
  // Manufacture
  const [selectedVendor ,setSelectedVendor] = useState(null);
  const [activeVendors, setActiveVendors] = useState([]);
  // Distributor
  const [activeDistributors, setActiveDistributors] = useState([]);
  const [selectedDistributor ,setSelectedDistributor] = useState(null);
  const [selectedDistributorPrice ,setSelectedDistributorPrice] = useState('');
  const [selectedDistributorCurrency ,setSelectedDistributorCurrency] = useState({});
  const [selectedDistributors, setSelectedDistributors] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({})
  const [selectedManufactureCurrency, setSelectedManufactureCurrency] = useState({});

  // Set token
  useEffect(() => {
    if(authToken){
      fetchAllSubProduct();
      fetchAllActiveManufacturer();
      fetchAllActiveDistributor();
    }
  }, [authToken]);


  // Momizing currency data
  const memoizedCurrencyData = useMemo(() => {
    return currencies.map((currency) => ({
      value: currency.code,
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={currency.flag}
            alt={`${currency.name} flag`}
            style={{ width: 20, height: 20, marginRight: 10 }}
          />
          <span>{`${currency.name} (${currency.code})`}</span>
        </div>
      ),
    }));
  }, [currencies]); 

  const formattedManufacturer = useMemo(()=>{
    return activeVendors?.map((item)=>({value : item.id, label :item.name}))
  },[activeVendors])

  const formattedDistributors = useMemo(()=>{
    const activeDistributorArr = [...activeDistributors]

    const formattedArray = activeDistributorArr.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    formattedArray.unshift({ value: '', label: 'No Distributor' });
    return formattedArray;
},[activeDistributors])


useEffect(() => {
  console.log("selectedProduct", selectedProduct);

  if (Object.keys(selectedProduct).length !== 0) {
    const { manufacture, currency, distributors } = selectedProduct.data;

    // Set manufacture if it exists
    if (manufacture) {
      setSelectedVendor({ label: manufacture.name, value: manufacture.id });
    }

    // Set manufacture currency if it exists
    if (currency) {
      const filteredCurrency = memoizedCurrencyData?.find(
        (item) => item.value === currency
      );
      setSelectedManufactureCurrency(filteredCurrency);
    }

    // Handle distributors and distributor currency
    if (distributors?.length > 0 && formattedDistributors?.length > 0) {
      const selectedDistributor = distributors.find((distributor) =>
        formattedDistributors.some((distributorOption) => distributorOption.value === distributor.id)
      );
      console.log("selectedDistributor",selectedDistributor);
      
      if (selectedDistributor) {
        setSelectedDistributor({
          label: selectedDistributor.name,
          value: selectedDistributor.id
        });

        const distributorCurrency = selectedDistributor.currency;
        if (distributorCurrency) {
          const filteredCurrency = memoizedCurrencyData?.find(
            (item) => item.value === distributorCurrency
          );
          setSelectedDistributorCurrency(filteredCurrency);
        }
      }
    }
  }
}, [selectedProduct, memoizedCurrencyData, formattedDistributors]);



  // Function for fetch all sub products
  async function fetchAllSubProduct(){
    try{
      let response = await getAllSubProductDetailsApi(authToken);
      if (response?.code == 200) {
        setSubProducts(response?.data || []);
      }
    }catch(err){
      console.log("err->", err.message);
    }
  }

  // Function for fetch active Manufacturer
  async function fetchAllActiveManufacturer() {
    try {
      
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllActiveManufacturersApi(authToken);
      if (response?.code == 200) {
        setActiveVendors(response?.data || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }


  // Function for fetch active Distributors
  async function fetchAllActiveDistributor() {
    try {
      
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllActiveDistributorsApi(authToken);
      if (response?.code == 200) {
        setActiveDistributors(response?.data || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }
  

  // Function for add selected distributor 
  const addSelectedDistributor = () =>{
    const isDistributorAlreadyExist  = selectedDistributors?.find((item)=>{
        return item.label == selectedDistributor.label
    })  

    if(isDistributorAlreadyExist){
      toast.error(`${selectedDistributor.label} already exist`)
      return
    }
    if(selectedDistributorPrice !=='' && Object.keys(selectedDistributorCurrency)?.length !==0){
      selectedDistributor.price = selectedDistributorPrice
      selectedDistributor.currency = selectedDistributorCurrency
      setSelectedDistributors((prev)=>([...prev, selectedDistributor]))
      toast.success(`${selectedDistributor.label} successfully added`)
    }else{
    
      toast.error(`Please ${Object.keys(selectedDistributorCurrency).length ==0 ? 'select currency' : 'enter a price'}  for ${selectedDistributor.label} before adding.`)
    }
  }
  
  // Function for handle selected distributor
  const handleDistributorSelectChange = (selectedOption) => {
    let isDistributorAlreadyExist = false
    if(selectedOption){
      isDistributorAlreadyExist  = selectedDistributors?.find((item)=>{
        return item.label == selectedOption.label
      })  
    }
    
    if(isDistributorAlreadyExist){
        setSelectedDistributorCurrency(isDistributorAlreadyExist.currency)
        setSelectedDistributorPrice(isDistributorAlreadyExist?.price)
    }else{
        setSelectedDistributorCurrency({});
        setSelectedDistributorPrice('');
    }

    setSelectedDistributor(selectedOption);

  };
    


  // Function handle open & close modal
  const toggle = () => {
    setSubProductModal(!subProductModal);
    if (!subProductModal) {
      // # Reset form to initial values when modal is closed
      subProduct.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setStoreTags([]);
      setSelectedVendor(null);
      setSelectedDistributor(null)
      setSelectedDistributorPrice('')
      setSelectedDistributorCurrency({});
      setSelectedDistributors([]);
    }
  };

  const subProduct = useFormik({
    initialValues: {
        name: "",
        image: null,
        part_number : "",
        manufacture: "",
        parent_product : "",
        distributors: [],
        currency: "",
        price: "",
        tags: [],
        attributes: {},
        data_sheet: null,
        user_manual: null,
        release_date: "",
        description: "",
        lead_time: "",
        transport_type : "",
        logistic_fee : 0,
        custom_fee : 0,
        total_shipment_charge : 0,
        logistic_buffer_charge : 0,
        warranty_period: "",
        warranty_terms: "",
    },
    validationSchema: Yup.object({

      // manufacture : Yup.string().required("Manufacture is required"),
      part_number : Yup.string()
      .matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {



      if(Object.keys(selectedProduct).length==0){
        setErrorMessage("Parent product is required.");
        return
      }
      if(Object.keys(selectedManufactureCurrency).length==0){
        setErrorMessage("Currency is required.");
        return
      }
      // if(selectedDistributor?.value =='' && selectedDistributors.length == 0){
      //   setErrorMessage("Add selected distributer");
      //   return
      // }
      
      if(selectedDistributors.length > 0){
        values.distributors = selectedDistributors.map((item)=>({id : item.value, price :  item.price, name : item.label, currency : item.currency.value}))
      }
      if(!selectedVendor){
        setErrorMessage("Manufacture is required");
        return
      }
      values.tags = storeTags;
      values.manufacture = selectedVendor?.value || "";
      values.parent_product = selectedProduct?.value || ""
      values.currency = selectedManufactureCurrency.value
      
      handleAddSubProduct(values);
    },
  });

  async function handleAddDistributor(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditDistributorApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllActiveDistributor();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Function handle sub product add functionality
  async function handleAddSubProduct(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      console.log("Values",values);
      
      let response = await handleAddSubProductApi(values, authToken);
      if (response?.code == 200) {
          setErrorMessage("");
          setSuccessMessage(response.message);
          fetchAllSubProduct(authToken)
          setSubProductModal(false);
      } else {
          setSuccessMessage("");
          setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }



  
  // Function for change products status 
  const handleChangeSubProductStatus = async(productId) =>{
    try{

      let response = await handleChangeSubProductStatusApi(productId, authToken);
      if (response?.code == 200) {
            const updatedProducts = subProducts.map((item)=>
            productId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
            setSubProducts(updatedProducts)
      } 
    }catch(error){
        console.log("error",error);
    }
  }

  // Function for handle selected Manufacture
  const handleManufactureSelectChange = (selectedOption) => {
  
    if(!selectedOption){
      setSelectedDistributors([])
      setSelectedDistributorCurrency({});
      setSelectedDistributorPrice('');
    }
    setSelectedVendor(selectedOption);
  };

  
  // Function for handle calculate shipment 
  function calculateTotalShipment(distributorPrice, logisticsFee, customFee, logisticBufferCharge) {
    
    const logisticsCharge = distributorPrice * (logisticsFee / 100);
    const customCharge = distributorPrice * (customFee / 100);
    const bufferCharge = distributorPrice * (logisticBufferCharge / 100);
    // parseFloat(distributorPrice) +
    let  ShipmentCharge =  parseFloat(logisticsCharge) + parseFloat(customCharge) + parseFloat(bufferCharge);
    const totalShipmentCharge = ShipmentCharge.toFixed(3)
    return totalShipmentCharge;
  }

  // Handling total shipping price
  useEffect(() => {
    let logisticsCharge = subProduct.values.logistic_fee;
    let customCharge = subProduct.values.custom_fee;
    let bufferCharge = subProduct.values.logistic_buffer_charge;
    
    if (selectedDistributorPrice) {
      if (logisticsCharge <= 0) {
        logisticsCharge = 0;
      }
      if (customCharge <= 0) {
        customCharge = 0;
      }
      if (bufferCharge <= 0) {
        bufferCharge = 0;
      }
      let totalShipmentCharge = calculateTotalShipment(selectedDistributorPrice, logisticsCharge, customCharge, bufferCharge);
      
      // Set the form field value
      subProduct.setFieldValue('total_shipment_charge', totalShipmentCharge);
    }
    
    // Dependencies: these trigger the effect when they change
  }, [
    subProduct.values.logistic_fee,
    subProduct.values.custom_fee,
    subProduct.values.logistic_buffer_charge,
    selectedDistributorPrice // Include this to recalculate when distributor price changes
  ]);

  // # Product loadOptions as an async function
  const loadProductOptions = async (inputValue) => {
    if (inputValue.trim().length <3) {
        return [];
    }
    

    // Fetch data from the API function
    const activeProductsArr = await fetchProductRelateManufacturesWithDistributors(inputValue);


    return activeProductsArr.map((item) => ({
        value: item.id,
        label: item.name,
        data : {
          currency : item?.currency,
          manufacture : item?.manufacture,
          distributors : item.distributors,
        }
    }));
  }
  // #Fetch Product details
  async function fetchProductRelateManufacturesWithDistributors(searchTerm) {
    try{
      if(!authToken){
        throw new Error('Token not found')
      }
      const isQuotation = false
      let response = await getProductRelateDetailsApi(authToken, searchTerm,isQuotation);
      if (response?.code == 200) {
        return response?.data 
      }
      return []
    }catch(error){
      console.log("message", error.message);
      
    }
  }
  const openPopUpPropsObj = {
    subProductModal,
    toggle,
    subProduct,
    memoizedCurrencyData,
    setErrorMessage,
    setSuccessMessage,
    errorMessage,
    successMessage,

    setStoreTags,
    storeTags,
    selectedVendor,
    handleManufactureSelectChange,
    formattedManufacturer,
    selectedDistributor,
    handleDistributorSelectChange,
    formattedDistributors,
    selectedDistributorCurrency,
    setSelectedDistributorCurrency,
    setSelectedDistributorPrice,
    selectedDistributorPrice,
    addSelectedDistributor,
    selectedDistributors,
    setSelectedDistributors,
    selectedProduct,
    setSelectedProduct,
    selectedManufactureCurrency,
    setSelectedManufactureCurrency,
    loadProductOptions,
    handleAddDistributor,

    
  }
  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={appName} breadcrumbItem="Supporting Products" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1 ">
                <Button color="success" onClick={toggle}>
                  Add Supporting Product
                </Button>
              </CardHeader>
              <MemoisedProductOpenPopUp
                {...openPopUpPropsObj}
              />
              <CardBody>
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Part No</th>
                      <th>Description</th>
                      <th>Manufacture</th>
                      {/* <th>Quantity</th> */}
                      <th>price</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subProducts?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.part_number}</td>
                        <td>{item.description}</td>
                        <td>{item.manufacture}</td>
                        {/* <td>{item.quantity}</td> */}
                        <td>{item.price} {item.currency}</td>
                        <td>
                          <Button  color={`${item.status == 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={()=>{handleChangeSubProductStatus(item.id)}}>
                            {item.status}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SubProduct;

const OpenPopUp = ({
  subProductModal,
  toggle,
  subProduct,
  memoizedCurrencyData,
  setErrorMessage,
  setSuccessMessage,
  errorMessage,
  successMessage,
  setStoreTags,
  storeTags,
  selectedVendor,
  handleManufactureSelectChange,
  formattedManufacturer,
  selectedDistributor,
  handleDistributorSelectChange,
  formattedDistributors,
  selectedDistributorCurrency,
  setSelectedDistributorCurrency,
  setSelectedDistributorPrice,
  selectedDistributorPrice,
  addSelectedDistributor,
  selectedDistributors,
  setSelectedDistributors,
  selectedProduct,
  setSelectedProduct,
  selectedManufactureCurrency,
  setSelectedManufactureCurrency,
  loadProductOptions,
  handleAddDistributor
}) => {
  // # Tags
  const [singleInpTagValue, setSingleInputTagValue] = useState("");
  const [singleInpTagValueError, setSingleInputTagValueError] = useState("");

  // Modal
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("");



  // Function to handle open & close modal
  const handleShow = () => {
    setShow(!show);
    setErrorMessage("")
    setSuccessMessage("")
    if (!show) {

    }
  };

  // Handle open & close modal
  const openModal = (type) => {
    setMode(type);
    handleShow();
  };

  const handleProductSelectChange =(selected)=>{
    console.log("selected",selected);
    
     setSelectedProduct(selected)
  }
  const handleChangeManufactureCurrency=(selected)=>{
    setSelectedManufactureCurrency(selected)
  }

  // Function for handle add new tag
  const handleAddNewTag = () => {
    if (storeTags.includes(singleInpTagValue.trim())) {
      setSingleInputTagValueError(`${singleInpTagValue} already exist`);
      return;
    }
    setSingleInputTagValueError("");
    if (singleInpTagValue.trim() !== "") {
      setStoreTags((prev) => [...prev, singleInpTagValue.trim()]);
    }
  };

  const handleDeleteDistributor = (index)=>{
    const updatedItems = selectedDistributors.filter((item, i) => i !== index);
    setSelectedDistributors(updatedItems);
  }

  // Function for handle delete tag
  const handleDeleteTag = (index) => {
    const updatedItems = storeTags.filter((item, i) => i !== index);
    setStoreTags(updatedItems);
  };

  return (
    <div>
      <Modal size="xl" isOpen={subProductModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Add Supporting Product</ModalHeader>
        <Form onSubmit={subProduct.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="sub_product_name">Name:</Label>
                  <Input
                    type="text"
                    value={subProduct.values.name}
                    required
                    onChange={subProduct.handleChange}
                    id="sub_product_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="sub_product_image">Image:</Label>
                  {subProduct.values?.image && (
                    <img
                      src={URL.createObjectURL(subProduct.values?.image)}
                      alt="Sub product Preview"
                      className="productImagePreview"
                    />
                  )}
                  <Input
                    type="file"
                    id="sub_product_image"
                    required
                    onChange={(event) =>
                      subProduct.setFieldValue(
                        "image",
                        event.currentTarget.files[0]
                      )
                    }
                    name="image"
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="sub_product_data_sheet">Data Sheet:</Label>
                  <Input
                    type="file"
                    id="sub_product_data_sheet"
                    onChange={(event) =>
                      subProduct.setFieldValue(
                        "data_sheet",
                        event.currentTarget.files[0]
                      )
                    }
                    name="data_sheet"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="sub_product_user_manual">User Manual:</Label>
                  <Input
                    type="file"
                    id="sub_product_user_manual"
                    onChange={(event) =>
                      subProduct.setFieldValue(
                        "user_manual",
                        event.currentTarget.files[0]
                      )
                    }
                    name="user_manual"
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* ------------------------------ */}
            <Row>
              {/* Part No */}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="subProductPartNumber">Part No:</Label>
                  <Input
                    type="text"
                    value={subProduct.values.part_number}
                    required
                    onChange={subProduct.handleChange}
                    id="subProductPartNumber"
                    name="part_number"
                  />
                </FormGroup>
                {subProduct.errors.part_number &&
                  subProduct.errors.part_number ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {subProduct.errors.part_number}
                    </div>
                  ) : null}
              </Col>

              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="parentProduct">Select Parent Product:</Label>
                  <AsyncSelect 
                    defaultOptions 
                    cacheOptions
                    placeholder="Search..."
                    loadingMessage={() => "Loading..."}
                    loadOptions={loadProductOptions} 
                    onChange={handleProductSelectChange}
                    value={selectedProduct} // Set default value to null if no product is selected
                  />

                </FormGroup>
              </Col>
              {Object.keys(selectedProduct).length !==0 && <>
                  {/* Currency */}
                  <Col md={3}>
                    <FormGroup>
                      <Label htmlFor="subProductCurrency">Currency:</Label>
                      <Select
                        options={memoizedCurrencyData}
                        placeholder="Select a currency..."
                        isSearchable
                        isDisabled={true} 
                        value={selectedManufactureCurrency}
                        onChange={handleChangeManufactureCurrency}
                      />
                    </FormGroup>
                  </Col>

                  {/* Manufacture */}
                  <Col md={3}>
                    <FormGroup>
                      <Label htmlFor="subProductManufacture">Manufacture:</Label>
                      <Select
                        value={selectedVendor}
                        onChange={handleManufactureSelectChange}
                        options={formattedManufacturer}
                        // name="manufacture"
                        isDisabled={true} 
                        isClearable={true} // To allow clearing the selection
                      />
                      {subProduct.errors.manufacture &&
                      subProduct.touched.manufacture ? (
                        <div className=" invalidError d-flex justify-content-center">
                          {subProduct.errors.manufacture}
                        </div>
                      ) : null}
                    </FormGroup>
                    
                  </Col>           
              </>}


              {/* Distributors */}
              {selectedVendor && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="subProductDistributor">Distributors:</Label>
                  <div className="d-flex">
                      <Select
                      className="w-100"
                        value={selectedDistributor}
                        onChange={handleDistributorSelectChange}
                        options={formattedDistributors}
                        isClearable={true} // To allow clearing the selection
                      />
                      <button
                          className="plusButton "
                          type="button"
                          onClick={() => openModal("DISTRIBUTOR")}
                        >
                        <i className="bi bi-plus-square"></i>
                      </button>
                  </div>
                </FormGroup>
              </Col>}
              {/* Distributors Currency */}
              { selectedVendor && selectedDistributor?.value && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="subProductDistributorCurrency">Distributor Currency:</Label>
                  <Select
                    options={memoizedCurrencyData}
                    placeholder="Select a currency..."
                    value={selectedDistributorCurrency}
                    isSearchable
                    onChange={(selectedOption) =>
                      setSelectedDistributorCurrency(selectedOption)
                    }
                  />
                  {/* {subProduct.errors.currency &&
                  subProduct.touched.currency ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {subProduct.errors.currency}
                    </div>
                  ) : null} */}
                </FormGroup>
              </Col>}
              {/* Distributor Price */}
              {selectedVendor && selectedDistributor?.value && selectedDistributorCurrency  && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="subProduct_distributor_Price">{selectedDistributor?.label} Price:</Label>
                  <div  className="d-flex">
                      <Input
                        type="number"
                        value={selectedDistributorPrice}
                        required
                        onChange={(e)=>{setSelectedDistributorPrice(e.target.value)}}
                        id="subProduct_distributor_Price"
                        name="distributor_Price"
                      />
              
                      <button
                          className="addButton bg-success"
                          type="button"
                          onClick={addSelectedDistributor}
                        >
                          Add
                      </button>
                      <button
                          className="viewButton bg-secondary"
                          type="button"
                          onClick={() => openModal("viewDistributor")}
                        >
                         View
                      </button>
                  </div>
                  
                </FormGroup>
              </Col>}


              {/* GBL price */}
              <Col md={3}>
                <Label htmlFor="subProductGlobalPrice">GPL Price</Label>
                <Input
                  type="number"
                  id="subProductGlobalPrice"
                  value={subProduct.values.gpl_price}
                  required
                  onChange={subProduct.handleChange}
                  name="gpl_price"
                />
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="subProductRelease_date">Release Date:</Label>
                  <Input
                    type="date"
                    id="subProductRelease_date"
                    value={subProduct.values.release_date}
                    required
                    onChange={subProduct.handleChange}
                    name="release_date"
                  />
                </FormGroup>
              </Col>
              {/* Tags */}
              <Col md={3}>
                <FormGroup className="d-flex flex-column align-items-center justify-content-center">
                  <Label className="subProductAddTagLabel">Add Tags:</Label>
                  <div className="d-flex justify-content-center">
                    <button
                      className="plusButton"
                      type="button"
                      onClick={() => openModal("tag")}
                    >
                      <i className="bi bi-bookmark-plus"></i>
                    </button>
                  </div>
                </FormGroup>
              </Col>
              <MemoisedNewItemPopUp
                  show={show}
                  toggle={handleShow}
                  mode={mode}
                  singleInpTagValue={singleInpTagValue}
                  setSingleInputTagValue={setSingleInputTagValue}
                  storeTags={storeTags}
                  handleAddNewTag={handleAddNewTag}
                  handleDeleteTag={handleDeleteTag}
                  singleInpTagValueError={singleInpTagValueError}
                  handleDeleteDistributor={handleDeleteDistributor}
                  selectedDistributors={selectedDistributors}
                  handleAddDistributor={handleAddDistributor}
                  errorMessage={errorMessage}
                  successMessage={successMessage}
              
              />
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="subProductDescription">Description</Label>
                  <textarea
                    className="selectInput"
                    id="subProductDescription"
                    name="description"
                    value={subProduct.values.description}
                    required
                    onChange={subProduct.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
               {/* Transport Type */}
              <Col md={2}>
                <FormGroup>
                  <Label htmlFor="subProductTransportType">Transport Type:</Label>
                  <div className="d-flex">
                    <select
                      className="selectInput"
                      id="subProductTransportType"
                      name="transport_type"
                      required
                      value={subProduct.values.transport_type}
                      onChange={subProduct.handleChange}
                    >
                      <option value={""}>Select type</option>
                      {transportType.map((item) => (
                        <option key={item.id} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    {subProduct.errors.transport_type ? (
                      <span className="invalidError">
                        {subProduct.errors.transport_type}
                      </span>
                    ) : null}
                  </div>
                </FormGroup>
              </Col>
              {/* Logistics Fee (%) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="subProductLogistic_fee">Logistics Fee (%):</Label>
                  <Input
                    id="subProductLogistic_fee"
                    type="number"
                    value={subProduct.values.logistic_fee}
                    required
                    onChange={subProduct.handleChange}
                    name="logistic_fee"
                  />
                </FormGroup>
              </Col>
              {/* Custom Fee (%) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="subProductCustom_fee">Custom Fee (%):</Label>
                  <Input
                    id="subProductCustom_fee"
                    type="number"
                    value={subProduct.values.custom_fee}
                    // required
                    onChange={subProduct.handleChange}
                    name="custom_fee"
                  />
                </FormGroup>
              </Col>
              {/* Logistic Buffer Charge (%) */}
              <Col md={3}>
                <FormGroup>
                  <Label for="subProductLogistic_buffer_charge">Logistic Buffer Charge (%):</Label>
                  <Input
                    id="subProductLogistic_buffer_charge"
                    type="number"
                    value={subProduct.values.logistic_buffer_charge}
                    // required
                    onChange={subProduct.handleChange}
                    name="logistic_buffer_charge"
                  />
                </FormGroup>
              </Col>
              {/* Total Shipment Charge (logistic_fee+ custom_fee + buffer) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="subProductTotal_shipment_charge">Total Shipment Charge:</Label>
                  <Input
                    id="subProductTotal_shipment_charge"
                    type="number"
                    value={subProduct.values.total_shipment_charge}
                    // required
                    readOnly={true}
                    // onChange={subProduct.handleChange}
                    name="total_shipment_charge"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="subProductLead_time">Lead time (days):</Label>
                  <Input
                    id="subProductLead_time"
                    type="number"
                    value={subProduct.values.lead_time}
                    required
                    onChange={subProduct.handleChange}
                    name="lead_time"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="subProductWarranty_period">Warranty Period (months):</Label>
                  <Input
                    id="subProductWarranty_period"
                    type="number"
                    value={subProduct.values.warranty_period}
                    required
                    onChange={subProduct.handleChange}
                    name="warranty_period"
                  />
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label for="subProductWarranty_terms">Warranty Terms:</Label>
                  <Input
                    id="subProductWarranty_terms"
                    value={subProduct.values.warranty_terms}
                    required
                    onChange={subProduct.handleChange}
                    name="warranty_terms"
                  />
                </FormGroup>
              </Col>
              {/* <Col md={2}>
                <FormGroup>
                  <Label for="stock_quantity">Stock Quantity:</Label>
                  <Input
                    id="stock_quantity"
                    type="number"
                    value={subProduct.values.stock_quantity}
                    required
                    onChange={subProduct.handleChange}
                    name="stock_quantity"
                  />
                </FormGroup>
              </Col> */}
            </Row>
            {/* ---------------------------- */}

          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};
const MemoisedProductOpenPopUp = memo(OpenPopUp);








function CreateNewItemPopup({
  show,
  toggle,
  mode,
  singleInpTagValue,
  setSingleInputTagValue,
  storeTags,
  handleAddNewTag,
  handleDeleteTag,
  singleInpTagValueError,
  handleDeleteDistributor,
  selectedDistributors,
  handleAddDistributor,
  errorMessage,
  successMessage,
}) {

  // Add Distributor Form
  const distributorForm = useFormik({
    initialValues: {
      name:  "",
      email: "",
      contact_person: "",
      contact_no: "",
    },
    validationSchema: Yup.object({
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {

      // Trim all string values
      const trimmedValues =  Object.keys(values).reduce((acc, key)=>{
          acc[key]  = typeof values[key] == 'string' ? values[key].trim() : values[key]  
          return acc
      },{})
      trimmedValues.isEdit  =  false
      handleAddDistributor(trimmedValues);
    },
  });
  return (
    <Modal size="md" isOpen={show} toggle={toggle}>
      <div className="modal-header">
        <h5 className={`modal-title `}>{mode == "tag" ? 'Add Tag' : ''}</h5>
        <Button onClick={toggle} close />
      </div>
      {mode === "DISTRIBUTOR" && (
          <Form onSubmit={distributorForm.handleSubmit}>
            <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Row className="d-flex justify-content-center">

                  <Col md={8}>
                    <FormGroup>
                      <Label htmlFor="distributer_name">Name:</Label>
                      <Input
                        type="text"
                        value={distributorForm.values.name}
                        required
                        onChange={distributorForm.handleChange}
                        id="distributer_name"
                        name="name"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={8}>
                    <FormGroup>
                    <Label htmlFor="distributer_email">Email:</Label>
                      <Input
                        type="email"
                        id="distributer_email"
                        value={distributorForm.values.email}
                        required
                        onChange={distributorForm.handleChange}
                        name="email"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={8}>
                    <FormGroup>
                      <Label htmlFor="vendor_contact_person">Contact Person:</Label>
                      <Input
                        type="text"
                        value={distributorForm.values.contact_person}
                        required
                        onChange={distributorForm.handleChange}
                        id="vendor_contact_person"
                        name="contact_person"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={8}>
                    <FormGroup>
                    <Label htmlFor="dist_contact_number">Contact Number:</Label>
                      <Input
                        type="text"
                        value={distributorForm.values.contact_no}
                        required
                        onChange={distributorForm.handleChange}
                        id="dist_contact_number"
                        name="contact_no"
                      />
                    </FormGroup>
                    {distributorForm.errors.contact_no &&
                      distributorForm.errors.contact_no ? (
                        <div className=" invalidError d-flex justify-content-center">
                          {distributorForm.errors.contact_no}
                        </div>
                      ) : null}
                  </Col>
                  <div className="modal-footer">
                    <Button type="submit" color="primary">
                        Submit
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                      Cancel
                    </Button>
                  </div>
              </Row>
          </Form>
      )}
      {mode !=='MANUFACTURE'  && mode !=='DISTRIBUTOR'&& 
        <>
         <div className={`newItemModalBody ${mode === "viewDistributor" ? 'p-5': ''}`}>
                {/* Tags Form */}
                {mode === "tag" && (
                  <>
                    <FormGroup className="ms-5">
                      <Label for="tag">Tag Name</Label>
                      <div className="d-flex">
                        <Input
                          type="text"
                          name="tag"
                          id="tag"
                          className="w-75 "
                          value={singleInpTagValue}
                          onChange={(e) => {
                            setSingleInputTagValue(e.target.value);
                          }}
                          required
                        />
                        <Button
                          type="button"
                          color="primary"
                          onClick={handleAddNewTag}
                        >
                          Add Tag
                        </Button>
                      </div>
                      {singleInpTagValueError && (
                        <span className="invalidError">{singleInpTagValueError}</span>
                      )}
                    </FormGroup>

                    <ul className="list-container">
                      {storeTags.map((item, index) => (
                        <li key={index} className="list-item">
                          <span className="item-text">{item}</span>
                          <button
                            className="delete-button"
                            onClick={() => handleDeleteTag(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {/* View Distributor */}
                {mode === "viewDistributor" &&(
                  <>
                  <Table bordered >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Currency</th>
                        <th>Price</th>
                        <th></th>
                      </tr>
                  </thead>
                  <tbody>
                  {selectedDistributors?.map((item, index) => (
                      <tr key={index}>
                        <td>{index+1}</td>
                        <td>{item.label}</td>
                        <td>{item.currency.value}</td>
                        <td>{item.price}</td>
                        <td>
                        <button
                            className="delete-button"
                            onClick={() => handleDeleteDistributor(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      
                      </tr>
                      ))}
                  </tbody>
                  </Table>
                  </>
                )}
          </div>
          <div className="modal-footer">
            {(mode == "category" || mode == "subcategory") && (
              <Button type="submit" color="primary">
                {mode === "category"
                  ? "Add Category"
                  : mode === "subcategory"
                  ? "Add Subcategory"
                  : ""}
              </Button>
            )}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </div>
        </>    
      }
    </Modal>
  );
}
// Memoizing component
const MemoisedNewItemPopUp = memo(CreateNewItemPopup);
